<template>
  <section>
    <notifications></notifications>
    <base-header>
      <div class="row align-items-center pt-header">
        <div class="col-lg-6 col-md-6 col-sm-6 col-6 d-flex align-items-center">
          <el-tooltip content="Back" placement="bottom">
            <base-button
              type="neutral"
              class="btn-icon-only"
              @click="goToPreviousPage()"
            >
              <i class="flaticon-left-1"></i>
            </base-button>
          </el-tooltip>

          <h1 class="title-view">{{ $route.meta.title }}</h1>
        </div>
        <div
          class="col-lg-6 col-md-6 col-sm-6 col-6 align-items-center text-right"
        >
          <div class="box-buttons">
            <base-dropdown
              v-if="mode === 'edit'"
              menu-on-right
              class="nav-item"
              tag="li"
              title-tag="a"
              title-classes="btn min-button btn-outline-neutral ml-2"
              title="Actions"
            >
              <base-button slot="title" type="none" class="p-0 min-button">
                <i class="flaticon-plus"></i>
                <strong class="d-lg-block d-none">Add</strong>
              </base-button>
              <div
                class="dropdown-item"
                @click="
                  openExtrasModal(reservation.service, reservation.customer)
                "
              >
                <span class="icon-action"> Add Extras </span>
              </div>

              <div
                class="dropdown-item"
                @click="
                  openDiscountModal(reservation.service, reservation.customer)
                "
              >
                <span class="icon-action"> Add Discount </span>
              </div>
            </base-dropdown>

            <base-button
              type="outline-neutral"
              @click="mode = 'view'"
              class="min-button no-mb ml-2"
              v-if="mode === 'edit' && service"
            >
              <i class="flaticon-view-1 icon-no-margin"></i>
              <strong class="d-lg-block d-none">View</strong>
            </base-button>

            <base-button
              type="outline-neutral"
              @click="mode = 'edit'"
              class="min-button no-mb ml-2"
              v-if="mode === 'view' && service"
            >
              <i class="flaticon-pencil icon-no-margin"></i>
              <strong class="d-lg-block d-none">Edit</strong>
            </base-button>

            <base-button
              type="primary"
              class="min-button no-mb ml-2"
              @click="saveReservation()"
              :disabled="buttonDisabled"
            >
              <i class="flaticon-floppy-disk icon-no-margin"></i>
              <strong class="d-lg-block d-none">Save</strong>
            </base-button>
          </div>
        </div>
      </div>
    </base-header>

    <div class="container-fluid forms mb-5">
      <div class="row">
        <div v-show="mode === 'view'" class="forms ticket">
          <div class="col-12">
            <div class="row">
              <div class="col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                <div class="row">
                  <div class="col-xl-12 col-lg-12 box-ticket">
                    <div class="row">
                      <div class="col-xl-12">
                        <div class="header-ticket">
                          <div class="row">
                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 alinmov1 align-self-center"
                            >
                              <span class="capitalize title-passenger">
                                {{ getTitleByGender(passenger.gender) }}
                                {{ passenger.firstName }}
                                {{ passenger.lastName }}
                              </span>

                              <span class="date-time">
                                {{
                                  formatPickupDate(
                                    reservation.pickup_date,
                                    formatDate
                                  )
                                }}
                                at
                                {{
                                  formatPickupTime(
                                    reservation.pickup_time,
                                    formatTime
                                  )
                                }}
                              </span>
                            </div>

                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 alinmov2 mt-sm-0 mt-3 align-self-center"
                            >
                              <span class="label-total"> TOTAL CHARGES: </span>

                              <span
                                class="price-total"
                                :class="
                                  reservation.pricing.totals.gross_price < 0
                                    ? 'loss-alert'
                                    : ''
                                "
                              >
                                {{ currency.symbol }}
                                {{
                                  normalizePriceAmount(
                                    reservation.pricing.totals.gross_price
                                  )
                                }}
                                {{ currency.code }}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-xl-12 col-lg-12">
                        <div class="card-ticket">
                          <div class="box">
                            <div class="row">
                              <div class="col-12 p-0">
                                <div class="col-12 mt-lg-0 mt-md-3 mt-sm-3">
                                  <div class="address-content">
                                    <div class="icon-pick">
                                      <i
                                        class="flaticon-start text-primary"
                                      ></i>
                                    </div>

                                    <div class="content">
                                      <span class="title-one"
                                        >Pickup:
                                        {{
                                          formatPickupTime(
                                            reservation.pickup_time,
                                            formatTime
                                          )
                                        }}
                                      </span>
                                      <span class="title-two">{{
                                        reservation.from
                                      }}</span>
                                    </div>
                                  </div>

                                  <div
                                    class="address-content mt-2"
                                    v-if="reservation.type !== 'hourly'"
                                  >
                                    <div class="icon-pick">
                                      <i
                                        class="flaticon-placeholder-1 text-success"
                                      ></i>
                                    </div>

                                    <div class="content">
                                      <span class="title-one">Dropoff </span>
                                      <span class="title-two">{{
                                        reservation.to
                                      }}</span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="box box-services">
                            <div class="row" v-if="service !== null">
                              <div
                                class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12"
                              >
                                <div class="row card-serv-v card-select">
                                  <div
                                    class="col-xl-2 col-md-2 col-sm-3 col-12 align-self-center alinmov4"
                                  >
                                    <img
                                      v-lazy="service.vehicle.image"
                                      class="img-fluid es-img-service"
                                      alt="Service Car"
                                    />
                                  </div>
                                  <div
                                    class="col-xl-5 col-lg-5 col-md-5 col-sm-9 col-12 align-self-center alinmov4 pl-sm-0 pr-0 bord-left"
                                  >
                                    <h2 class="title-serv">
                                      {{
                                        formatVehicleCategory(
                                          service.vehicle.category
                                        )
                                      }}
                                      {{ service.vehicle.seats }} seats
                                    </h2>

                                    <span class="type-card"
                                      >{{ service.vehicle.make_label }} or
                                      Similar</span
                                    >

                                    <div class="descrip">
                                      <span>
                                        <i class="flaticon-people-1"></i>
                                        PAX:
                                        {{ service.vehicle.seats }}
                                      </span>

                                      <span>
                                        <i class="flaticon-briefcase"></i>
                                        Bags: {{ service.vehicle.suitcases }}
                                      </span>
                                    </div>

                                    <div class="more-details">
                                      <ul class="mb-0">
                                        <li v-if="service.preference.wifi">
                                          WiFi onboard
                                        </li>
                                        <li v-if="service.preference.water">
                                          Water
                                        </li>
                                        <li
                                          v-if="
                                            service.preference.hand_sanitizer
                                          "
                                        >
                                          Hand Sanitizer
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                  <div
                                    class="col-xl-5 col-lg-5 col-md-5 col-sm-12 col-12 alinmov8 align-self-center pl-lg-0"
                                  >
                                    <div class="box-driver" v-if="driver">
                                      <div class="text-center">
                                        <label class="title-box"
                                          >Driver Information
                                        </label>
                                      </div>
                                      <div class="card-driver">
                                        <div class="content-image">
                                          <div
                                            class="img-driver"
                                            v-bind:style="{
                                              backgroundImage: driver.profile
                                                .image
                                                ? `url('${driver.profile.image}')`
                                                : 'url(' + imageProfile + ')'
                                            }"
                                          ></div>
                                        </div>

                                        <div class="content">
                                          <div class="item-content">
                                            <label>Driver: </label>
                                            <span
                                              >{{
                                                getTitleByGender(
                                                  driver.person.gender
                                                )
                                              }}
                                              {{ driver.person.first_name }}
                                              {{
                                                driver.person.last_name
                                              }}</span
                                            >
                                          </div>
                                          <div
                                            class="item-content"
                                            :class="{
                                              'mb-0': !driver.person
                                                .numbre_phone
                                            }"
                                          >
                                            <label>Phone: </label
                                            ><span
                                              ><a
                                                :href="
                                                  `tel:${driver.person.numbre_phone}`
                                                "
                                                >{{
                                                  driver.person.numbre_phone
                                                }}</a
                                              >
                                              <el-tooltip
                                                content="Copy"
                                                placement="bottom"
                                              >
                                                <span
                                                  class="curp ml-2"
                                                  v-clipboard:copy="
                                                    driver.person.numbre_phone
                                                  "
                                                  v-clipboard:success="onCopy"
                                                  v-clipboard:error="
                                                    onErrorCopy
                                                  "
                                                >
                                                  <i
                                                    class="flaticon-copy link ml-0"
                                                  ></i></span></el-tooltip
                                            ></span>
                                          </div>

                                          <div
                                            class="item-content"
                                            :class="{
                                              'mb-0': !driver.account.email
                                            }"
                                            v-if="driver.account.email"
                                          >
                                            <label>Email: </label>
                                            <span
                                              ><a
                                                :href="
                                                  `https://mail.google.com/mail/?view=cm&fs=1&to=${driver.account.email}`
                                                "
                                                >{{ driver.account.email }}</a
                                              >
                                              <el-tooltip
                                                content="Copy"
                                                placement="bottom"
                                              >
                                                <span
                                                  class="curp ml-2"
                                                  v-clipboard:copy="
                                                    driver.account.email
                                                  "
                                                  v-clipboard:success="onCopy"
                                                  v-clipboard:error="
                                                    onErrorCopy
                                                  "
                                                >
                                                  <i
                                                    class="flaticon-copy link ml-0"
                                                  ></i>
                                                </span>
                                              </el-tooltip>
                                            </span>
                                          </div>
                                        </div>
                                      </div>
                                    </div>

                                    <div class="box-driver" v-else>
                                      <div class="text-center">
                                        <label class="title-box"
                                          >Driver Information
                                        </label>
                                      </div>

                                      <base-alert
                                        type="warning"
                                        class="info-min text-center"
                                      >
                                        <i class="flaticon-warning mr-1"></i>
                                        <strong>No driver assigned!</strong>
                                        Wait for driver assignment
                                      </base-alert>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div class="box">
                            <div class="row">
                              <div
                                class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12"
                              >
                                <div class="data-block">
                                  <span class="title-block">Type Transfer</span>
                                  <span class="content-block">
                                    {{ formatBookingType(reservation.type) }}
                                  </span>
                                </div>
                              </div>

                              <div
                                class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12"
                                v-if="reservation.type != 'journey'"
                              >
                                <div class="data-block">
                                  <span class="title-block">
                                    {{ getLabelTransport(reservation.type) }}
                                  </span>
                                  <span
                                    class="content-block"
                                    :class="{
                                      'text-link':
                                        isFlightType &&
                                        reservation.flight_number,
                                      uppercase:
                                        reservation.type !== 'hourly' &&
                                        getTransportReference(reservation)
                                    }"
                                    @click="
                                      getFlightsInformationByIdent(
                                        reservation.flight_number
                                      )
                                    "
                                  >
                                    {{
                                      getTransportReference(reservation) ||
                                        "Not included"
                                    }}
                                    <i
                                      v-if="
                                        isFlightType &&
                                          reservation.flight_number
                                      "
                                      class="flaticon-link"
                                    ></i
                                  ></span>

                                  <base-alert
                                    type="info"
                                    class="mb-0"
                                    v-if="loaderVerifyFlight"
                                  >
                                    <div class="d-flex align-items-center">
                                      <img
                                        src="~rhomtrip_assets/src/img/icons/loaders/loader-1.gif"
                                        alt="loader"
                                        class="d-inline mr-2"
                                      />
                                      <span class="d-inline info-min"
                                        ><strong class="d-block"
                                          >Verifying flight... </strong
                                        >Redirecting to flight tracking
                                        page…</span
                                      >
                                    </div>
                                  </base-alert>
                                </div>
                              </div>
                              <div
                                class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12"
                              >
                                <div class="data-block">
                                  <span class="title-block">PAX N°</span>
                                  <span class="content-block"
                                    >{{ reservation.passengersCount }} PAX
                                  </span>
                                </div>
                              </div>

                              <div
                                class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12"
                              >
                                <div class="data-block">
                                  <span class="title-block">PAX</span>
                                  <span class="content-block">
                                    {{ getTitleByGender(passenger.gender) }}
                                    {{ passenger.fullName }}</span
                                  >
                                </div>
                              </div>

                              <div
                                class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12"
                              >
                                <div class="data-block">
                                  <span class="title-block"
                                    >Contact Number</span
                                  >
                                  <span class="content-block"
                                    >{{ passenger.phone }}
                                    <el-tooltip
                                      content="Copy"
                                      placement="bottom"
                                    >
                                      <span
                                        class="curp ml-2"
                                        v-clipboard:copy="passenger.phone"
                                        v-clipboard:success="onCopy"
                                        v-clipboard:error="onErrorCopy"
                                      >
                                        <i
                                          class="flaticon-copy link ml-0"
                                        ></i></span></el-tooltip
                                  ></span>
                                </div>
                              </div>

                              <div
                                class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12"
                                v-if="customer"
                              >
                                <div class="data-block">
                                  <span class="title-block">Customer</span>
                                  <span class="content-block">
                                    <a
                                      class="capitalize"
                                      :href="
                                        [
                                          'travel_agency',
                                          'travel_access'
                                        ].includes(customer.type)
                                          ? `/partners/${customer._id}`
                                          : `/edit-costumer/${customer._id}`
                                      "
                                      target="_blank"
                                      >{{ customer.first_name }}
                                      {{ customer.last_name }}
                                    </a>
                                    <span class="type-card">
                                      -
                                      {{
                                        parseCustomerType(customer.type)
                                      }}</span
                                    >
                                  </span>
                                </div>
                              </div>

                              <div
                                class="col-xl-4 col-lg-4 col-md-4 col-sm-6 col-12"
                              >
                                <div class="data-block">
                                  <span class="title-block">Pickup Sign</span>
                                  <div v-if="pdfDataUrl" class="content-block">
                                    <span
                                      class="link ml-0"
                                      @click="openPreviewPickup()"
                                    >
                                      <i class="flaticon-visualization mr-1"></i
                                      >File uploaded</span
                                    >
                                  </div>

                                  <div v-else>
                                    <span
                                      class="content-block"
                                      v-if="reservation.pickupSign.text"
                                      >{{ reservation.pickupSign.text }}</span
                                    >

                                    <span class="content-block" v-else
                                      >NONE</span
                                    >
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-xl-12 col-12 mt-4">
                        <div class="card py-3">
                          <div class="row">
                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12"
                            >
                              <h4 class="subtitle mb-1">Payment Details</h4>

                              <div class="item-selected">
                                <span>
                                  <strong>Payment Type: </strong>
                                  {{
                                    formatPaymentType(reservation.payment_type)
                                  }}
                                </span>
                              </div>

                              <div
                                class="item-selected"
                                v-if="reservation.invoice_number"
                              >
                                <span>
                                  <strong>Invoice N°: </strong>
                                  {{ reservation.invoice_number }}
                                  <el-tooltip content="Copy" placement="bottom">
                                    <span
                                      class="curp ml-2"
                                      v-clipboard:copy="
                                        reservation.invoice_number
                                      "
                                      v-clipboard:success="onCopy"
                                      v-clipboard:error="onErrorCopy"
                                    >
                                      <i class="flaticon-copy link ml-0"></i>
                                    </span> </el-tooltip
                                ></span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-4 col-lg-12">
                <Charges
                  :serviceType="'transfer'"
                  :operation="'new'"
                  :currency="currency"
                  :pricing="reservation.pricing"
                  @addAdjustments="addAdjustments"
                />
              </div>
            </div>
          </div>
        </div>

        <div v-show="mode === 'edit'" class="forms">
          <div class="col-12">
            <div class="row">
              <div class="col-xl-8 col-lg-12 col-md-12 col-sm-12 col-12">
                <div class="row">
                  <div class="col-12">
                    <div class="card pb-4">
                      <h2 class="subtitle">Type Transfer</h2>
                      <div
                        class="option-transfers d-xl-block d-lg-block d-md-block d-sm-block d-none"
                      >
                        <b-form-radio-group
                          id="btn-radios-1"
                          v-model="reservation.type"
                          :options="reservationOptions"
                          name="radios-btn-default"
                          buttons
                          value-field="value"
                          text-field="label"
                          button-variant="group-neutral"
                          tabindex="1"
                          class="buttons-type"
                          @change="changeReservationTransferType"
                        ></b-form-radio-group>
                      </div>

                      <div
                        class="d-xl-none d-lg-none d-md-none d-sm-none d-block"
                      >
                        <WSelect
                          placeholder="Reservation Type"
                          v-model="reservation.type"
                          filterable
                          id="reservationType"
                          class="mb-0"
                        >
                          <el-option
                            v-for="option in reservationOptions"
                            :value="option.value"
                            :label="option.label"
                            :key="option.label"
                          ></el-option>
                        </WSelect>
                      </div>
                    </div>
                  </div>

                  <!-- address/date/time/ -->
                  <div class="col-xl-12">
                    <div class="card">
                      <h2 class="subtitle mb-4">Address / Date & Time</h2>
                      <div class="row">
                        <div class="col-12">
                          <WSelect
                            label="From"
                            v-bind:class="{
                              'is-invalid': $v.reservation.from.$error
                            }"
                            id="from"
                            name="from"
                            filterable
                            remote
                            reserve-keyword
                            :remote-method="getLocationFrom"
                            :loading="loading"
                            placeholder="Address or Hotel Name"
                            v-model="$v.reservation.from.$model"
                            @change="selectFrom"
                            indexTab="2"
                            ref="from"
                            :focusact="true"
                            no-data-text="Search by destination or landmark"
                            clearable
                            allText
                            :error="fromValidationMessage($v.reservation.from)"
                            markrequired
                          >
                            <el-option
                              v-for="(location, index) in optionsFrom"
                              class
                              :value="location.select"
                              :label="location.select"
                              :key="`${index}`"
                            >
                              <div class="d-flex align-items-center">
                                <i :class="getIcon(location.type)"></i>
                                <span class="ml-3">
                                  {{ location.select }}
                                </span>
                              </div>
                            </el-option>
                          </WSelect>
                        </div>

                        <div
                          class="col-12"
                          v-show="reservation.type !== 'hourly'"
                        >
                          <WSelect
                            label="To"
                            v-bind:class="{
                              'is-invalid': $v.reservation.to.$error
                            }"
                            id="to"
                            name="to"
                            filterable
                            remote
                            reserve-keyword
                            :remote-method="getLocationTo"
                            :loading="loading"
                            placeholder="Address or Hotel Name"
                            v-model="$v.reservation.to.$model"
                            indexTab="3"
                            @change="selectTo"
                            no-data-text="Search by destination or landmark"
                            clearable
                            allText
                            :error="toValidationMessage($v.reservation.to)"
                            markrequired
                          >
                            <el-option
                              v-for="(location, index) in optionsTo"
                              :value="location.select"
                              :label="location.select"
                              :key="`${index}`"
                            >
                              <div class="d-flex align-items-center">
                                <i :class="getIcon(location.type)"></i>
                                <span class="ml-3">
                                  {{ location.select }}
                                </span>
                              </div>
                            </el-option>
                          </WSelect>
                        </div>

                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                          <base-input
                            label="Pickup Date"
                            :error="
                              $v.reservation.pickup_date.$error
                                ? `Select Pickup Date`
                                : ''
                            "
                            markrequired
                          >
                            <flat-picker
                              slot-scope="{ focus, blur }"
                              @on-open="focus"
                              @on-close="blur"
                              :config="{
                                altFormat: formatDateFlatPicker,
                                altInput: true,
                                minDate: 'today',
                                dateFormat: 'Y-m-d',
                                allowInput: true
                              }"
                              class="input-custom"
                              v-model="reservation.pickup_date"
                              @input="getRatesWithThePickupDate"
                              id="date"
                              name="date"
                              placeholder="Pickup Date"
                              tabindex="4"
                            ></flat-picker>
                          </base-input>
                        </div>
                        <div class="col-xl-2 col-lg-3 col-md-3 col-sm-6 col-12">
                          <base-input
                            label="Pickup Time"
                            :error="
                              $v.reservation.pickup_time.$error
                                ? `Select Pickup Time`
                                : ''
                            "
                            markrequired
                          >
                            <flat-picker
                              slot-scope="{ focus, blur }"
                              @on-open="focus"
                              @on-close="blur"
                              :config="{
                                altFormat: formatTimeFlatPicker.altFormat,
                                enableTime: true,
                                noCalendar: true,
                                dateFormat: formatTimeFlatPicker.dateFormat,
                                time_24hr: formatTimeFlatPicker.time_24hr,
                                wrap: true
                              }"
                              class="input-custom"
                              v-model="reservation.pickup_time"
                              @input="getRatesWithThePickupTime"
                              id="time"
                              name="time"
                              placeholder="Pickup Time"
                              tabindex="5"
                            ></flat-picker>
                          </base-input>
                        </div>
                        <div class="col-xl-2 col-lg-3 col-md-3 col-sm-6 col-6">
                          <base-input
                            class
                            type="number"
                            v-auto-zero
                            v-model.number="
                              $v.reservation.passengersCount.$model
                            "
                            label="PAX N°"
                            placeholder="PAX N°"
                            id="passengers"
                            name="passengers"
                            mode="integer"
                            indexTab="6"
                            markrequired
                            :error="
                              passengerCountValidationMessage(
                                $v.reservation.passengersCount
                              )
                            "
                            @input="getRatesWithTheNumberPassengers"
                          />
                        </div>

                        <div
                          class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12 form-group"
                          v-if="
                            ['airport', 'arrival', 'departure'].includes(
                              reservation.type
                            )
                          "
                        >
                          <FlightNumberInput
                            v-model="$v.reservation.flight_number.$model"
                            :pickupDate="reservation.pickup_date"
                            :pickupTime="reservation.pickup_time"
                            :flightType="getFlightType(reservation.type)"
                            :validation="$v.reservation.flight_number"
                            :airport="airport"
                            @input="onFlightNumberInput"
                            @validation-state="handleValidationState"
                            @selectFlight="handleFlightSelection"
                          />
                        </div>
                        <div
                          class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 mb-3"
                          v-if="reservation.type === 'station'"
                        >
                          <base-input
                            v-model.trim="$v.reservation.number_stations.$model"
                            label="Rail Line"
                            id="rail_line"
                            name="rail_line"
                            placeholder="Rail Line"
                            indexTab="8"
                            @input="changeRouterReference"
                            :error="
                              $v.reservation.number_stations.$error
                                ? 'Enter a Valid Rail Line'
                                : ''
                            "
                          />
                        </div>

                        <div
                          class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-6 mb-3"
                          v-if="reservation.type === 'port'"
                        >
                          <base-input
                            v-model.trim="$v.reservation.cruise_line.$model"
                            label="Cruise Ship"
                            id="cruise_line"
                            name="cruise_line"
                            placeholder="Cruise Ship"
                            indexTab="8"
                            @input="changeRouterReference"
                            :error="
                              $v.reservation.cruise_line.$error
                                ? 'Enter a Valid Cruise Ship'
                                : ''
                            "
                          />
                        </div>

                        <div
                          class="col-xl-2 col-lg-3 col-md-3 col-sm-6 col-6 mb-3"
                          v-if="reservation.type === 'hourly'"
                        >
                          <WSelect
                            class
                            v-bind:class="{
                              'is-invalid': $v.reservation.number_hourly.$error
                            }"
                            placeholder="Select Hourly"
                            v-model.trim="$v.reservation.number_hourly.$model"
                            @input="getRatesWithTheHourly"
                            id="number_hourly"
                            name="number_hourly"
                            indexTab="8"
                            label="Hourly"
                            @change="changeRouterReference"
                            :error="
                              $v.reservation.number_hourly.$error
                                ? 'Select an Hours'
                                : ''
                            "
                          >
                            <el-option
                              v-for="number in minimumSelect"
                              :value="number"
                              :label="number"
                              :key="number"
                            ></el-option>
                          </WSelect>
                        </div>

                        <div
                          class="col-12"
                          v-if="reservation.flight_number && flight"
                        >
                          <FlightDetails mode="view" :flight="flight" />
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- service/DESTINATION -->
                  <div class="col-xl-12">
                    <div
                      class="card pb-4"
                      v-bind:class="{
                        'invalid-card': $v.reservation.service.$error
                      }"
                    >
                      <div class="row">
                        <div
                          class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 align-self-center"
                        >
                          <h2 class="subtitle">Service / Destination</h2>
                        </div>
                        <div
                          class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12 text-right form-group-no-margin align-self-center"
                        >
                          <div
                            class="service-filters"
                            v-if="services.length > 0"
                          >
                            <div class="col-filter mr-0 no-mov">
                              <WSelect
                                placeholder="Destination"
                                v-model="branchFilter"
                                id="branchFilter"
                                name="branchFilter"
                                filterable
                                indexTab="10"
                                @change="changeBranch"
                                label="Destination"
                                class="select-filter"
                                clearable
                              >
                                <el-option
                                  v-for="branch in branchesOptions"
                                  :value="branch._id"
                                  :label="branch.name"
                                  :key="branch._id"
                                ></el-option>
                              </WSelect>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mt-2">
                        <div class="col-xl-12">
                          <base-alert
                            v-if="loaderService == 'INIT'"
                            type="info"
                            class="info-min mb-0"
                          >
                            <i class="flaticon-warning mr-1"></i>
                            <strong>Waiting search!</strong>
                            Select Address, Date and PAX N° to see the available
                            services
                          </base-alert>
                          <base-alert
                            v-if="loaderService == 'NOT_FOUND'"
                            type="danger"
                            class="info-min mb-0"
                          >
                            <i class="flaticon-warning mr-1"></i>
                            <strong>Not Found!</strong> There are no services
                            available for your search. Check the from and to.
                          </base-alert>

                          <div class="container-services">
                            <div class="content-service">
                              <div
                                class="row"
                                v-if="loaderService === 'RESULTS'"
                              >
                                <div
                                  class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pad-org"
                                  v-for="(element, index) in serviceAux"
                                  :key="index"
                                >
                                  <ServicesCard
                                    :branches="branchesOptions"
                                    :selected="
                                      getSelectServices(service, element)
                                    "
                                    :transferType="reservation.type"
                                    :service="element"
                                    @selectService="processServiceSelection"
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                          <div v-if="loaderService === 'SEARCHING'">
                            <div class="text-center pt-0 pb-4">
                              <h4><strong>Finding services...</strong></h4>
                              <span class="loader-pin"></span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- Driver -->
                  <div class="col-xl-12">
                    <div class="card">
                      <h2 class="subtitle mb-4">Driver</h2>
                      <div class="row">
                        <div
                          class="col-xl-6 col-lg-6 col-md-7 col-sm-8 col-9 no-margin mb-4"
                        >
                          <WSelect
                            placeholder="Select Driver"
                            id="driver"
                            v-model="driverId"
                            @change="changeDriver"
                            name="driver"
                            indexTab="13"
                            clearable
                            filterable
                            label="Driver Assigned"
                          >
                            <el-option
                              v-for="(item, index) in driversOptions"
                              :value="item._id"
                              :label="
                                `${item.person.first_name} ${item.person.last_name}`
                              "
                              :key="index"
                            ></el-option>
                          </WSelect>
                        </div>

                        <div class="col-xl-4 col-lg-4 col-md-3 col-sm-4 col-3">
                          <base-button
                            @click="showAddModalDriver = true"
                            class="min-button"
                            type="outline-neutral"
                          >
                            <i
                              class="flaticon-plus mr-1 d-sm-inline-block d-none"
                            ></i>
                            <span class="d-sm-inline-block d-none">
                              Add New</span
                            >
                            <span class="d-sm-none d-inline-block"> Add</span>
                          </base-button>
                        </div>
                      </div>

                      <div class="row" v-if="driver">
                        <div class="col-xl-12 mb-4">
                          <div class="row">
                            <div
                              class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-11 align-self-center"
                            >
                              <div class="box-card-lic" v-if="driver">
                                <div class="card-person link-img-profile">
                                  <a
                                    :href="`/edit-driver/${driver._id}`"
                                    target="blank"
                                  >
                                    <div
                                      class="img-driver"
                                      v-bind:style="{
                                        backgroundImage: driver.profile.image
                                          ? `url('${driver.profile.image}')`
                                          : 'url(' + imageProfile + ')'
                                      }"
                                    ></div>
                                  </a>
                                  <div class="content">
                                    <div>
                                      <label>Driver: </label
                                      ><span
                                        >{{ driver.person.first_name }}
                                        {{ driver.person.last_name }}</span
                                      >
                                    </div>
                                    <div>
                                      <label>Phone: </label
                                      ><span
                                        ><a
                                          :href="
                                            `tel:${driver.person.numbre_phone}`
                                          "
                                          >{{ driver.person.numbre_phone }}</a
                                        >
                                      </span>
                                    </div>
                                    <div v-if="driver.account.email">
                                      <label>Email: </label>
                                      <span
                                        ><a
                                          :href="
                                            `mailto:${driver.account.email}`
                                          "
                                          >{{ driver.account.email }}</a
                                        >
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>

                            <div
                              class="col-xl-1 col-lg-1 col-md-1 col-sm-1 col-1 text-left pl-0 align-self-center"
                            >
                              <el-tooltip content="Edit" placement="bottom">
                                <a
                                  class="icon-action text-blue mr-2 d-block"
                                  :href="`/edit-driver/${driver._id}`"
                                  target="blank"
                                >
                                  <i class="flaticon-pencil text-primary"></i>
                                </a>
                              </el-tooltip>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <!-- customer/passenger -->
                  <div class="col-xl-12">
                    <div class="card pb-3">
                      <h2 class="subtitle mb-4">Customer / PAX</h2>
                      <div class="row">
                        <div
                          class="col-xl-6 col-lg-6 col-md-7 col-sm-8 col-9 no-margin mb-4"
                        >
                          <WSelect
                            label="Customer"
                            v-bind:class="{
                              'is-invalid': $v.reservation.customer.$error
                            }"
                            filterable
                            remote
                            :remote-method="getCustomer"
                            :loading="loading"
                            placeholder="Enter Name Customer"
                            v-model="$v.reservation.customer.$model"
                            id="customer"
                            name="customer"
                            indexTab="13"
                            @input="selectCustomer"
                            no-data-text="Search by Customer"
                            clearable
                            markrequired
                          >
                            <el-option
                              v-for="(customer, index) in customers"
                              :value="customer._id"
                              :label="
                                `${
                                  customer.company_name !== ''
                                    ? customer.company_name
                                    : customer.first_name +
                                      ' ' +
                                      customer.last_name
                                }`
                              "
                              :key="index"
                            >
                              <div class="row">
                                <div class="col-7">
                                  <span
                                    class="capitalize hide-data"
                                    v-if="customer.company_name !== ''"
                                    >{{ customer.company_name }}
                                  </span>
                                  <span v-else
                                    >{{ customer.first_name }}
                                    {{ customer.last_name }}</span
                                  >
                                </div>
                                <div class="col-5 text-right hide-data">
                                  <span class="coin-right">{{
                                    parseCustomerType(customer.type)
                                  }}</span>
                                </div>
                              </div>
                            </el-option>
                          </WSelect>
                          <small
                            class="invalid-feedback"
                            v-if="$v.reservation.customer.$error"
                            >Enter a Customer</small
                          >

                          <div v-if="copyData" class="text-right">
                            <base-button
                              class="linkfill"
                              @click="copyDataCustomer"
                              tabindex="14"
                              >+ Fill Customer Data</base-button
                            >
                          </div>
                        </div>
                        <add-customers
                          :show="modalCustomer"
                          @closeNewCustomerModal="closeNewCustomerModal"
                          @customer="addCustomerInOptions"
                        ></add-customers>

                        <div class="col-xl-6 col-lg-4 col-md-3 col-sm-4 col-3">
                          <base-button
                            @click="modalCustomer = true"
                            class="min-button"
                            type="outline-neutral"
                          >
                            <i
                              class="flaticon-plus mr-1 d-sm-inline-block d-none"
                            ></i>
                            <span class="d-sm-inline-block d-none">
                              Add New</span
                            >
                            <span class="d-sm-none d-inline-block"> Add</span>
                          </base-button>
                        </div>

                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                          <base-input
                            v-model.trim="passenger.firstName"
                            label="PAX First Name"
                            placeholder="PAX First Name"
                            id="first_name_passenger"
                            name="first_name_passenger"
                            format="capitalize"
                            indexTab="16"
                            @input="populatePassengers()"
                            :error="
                              !$v.passenger.firstName.minLength ||
                              !$v.passenger.firstName.ValName
                                ? `Minimum 2 letters`
                                : ''
                            "
                          />
                        </div>

                        <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4 col-12">
                          <base-input
                            v-model.trim="passenger.lastName"
                            label="PAX Last Name"
                            placeholder="PAX Last Name"
                            indexTab="17"
                            id="last_name_passenger"
                            format="capitalize"
                            name="last_name_passenger"
                            @input="populatePassengers()"
                            :error="
                              !$v.passenger.lastName.minLength ||
                              !$v.passenger.lastName.ValName
                                ? `Minimum 2 letters`
                                : ''
                            "
                          />
                        </div>

                        <div
                          class="col-xl-3 col-lg-3 col-md-3 col-sm-4 col-12 mb-4"
                        >
                          <label for="title" class="title-label">Title</label>

                          <b-form-group
                            v-slot="{ ariaDescribedby }"
                            class="mb-0"
                          >
                            <b-form-radio-group
                              id="radio-gender"
                              v-model="passenger.gender"
                              :aria-describedby="ariaDescribedby"
                              name="radio-gender"
                              buttons
                              button-variant="outline-neutral"
                              size="md"
                              @change="populatePassengers()"
                            >
                              <b-form-radio
                                value="male"
                                class="pc-4"
                                tabindex="15"
                                >Mr.</b-form-radio
                              >
                              <b-form-radio value="female" class="pc-4"
                                >Mrs.</b-form-radio
                              >
                              <b-form-radio value="other" class="pc-4"
                                >Mx.</b-form-radio
                              >
                            </b-form-radio-group>
                          </b-form-group>
                        </div>

                        <div class="col-xl-5 col-lg-6 col-md-6 col-sm-6 col-12">
                          <base-input
                            v-model.trim="passenger.email"
                            label="PAX Email"
                            placeholder="PAX Email"
                            indexTab="18"
                            id="passenger_email"
                            name="passenger_email"
                            format="lowercase"
                            @input="populatePassengers()"
                            :error="
                              !$v.passenger.email.minLength ||
                              !$v.passenger.email.email
                                ? `Enter a valid email`
                                : ''
                            "
                          />
                        </div>
                        <div
                          class="col-xl-4 col-lg-6 col-md-6 col-sm-6 col-12 inputphone"
                        >
                          <label class="title-label">Contact Number</label>
                          <vue-tel-input
                            v-model="contactNumber"
                            key="NumberPhone"
                            inputId="NumberPhone"
                            name="NumberPhone"
                            required
                            mode="international"
                            inputClasses="input no-err"
                            :dynamicPlaceholder="true"
                            :disabledFetchingCountry="true"
                            :validCharactersOnly="true"
                            @input="phoneInput"
                            :inputOptions="{ tabindex: 19 }"
                          ></vue-tel-input>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-xl-12">
                    <div class="card pb-3">
                      <h2 class="subtitle">Pickup Sign</h2>

                      <div class="row">
                        <div
                          class="col-xl-8 col-lg-8 col-md-8 col-sm-12 col-12 align-self-center"
                        >
                          <div v-if="pdfDataUrl">
                            <div class="pdfPreview mb-4">
                              <iframe
                                :src="pdfDataUrl"
                                width="235px"
                                height="160px"
                                frameborder="0"
                                allowfullscreen
                                class="pdf-iframe"
                                scrolling="no"
                              ></iframe>

                              <el-tooltip
                                content="Open / Expand"
                                placement="bottom"
                              >
                                <div
                                  class="overlay-expand"
                                  @click="openPreviewPickup()"
                                >
                                  <i class="flaticon-expand"></i></div
                              ></el-tooltip>

                              <el-tooltip
                                content="Remove Pickup Sign"
                                placement="bottom"
                              >
                                <div
                                  class="overlay-remove"
                                  @click="clearfile()"
                                >
                                  <i class="flaticon-delete"></i></div
                              ></el-tooltip>
                            </div>
                          </div>

                          <el-input
                            v-else
                            v-model="reservation.pickupSign.text"
                            placeholder="Pickup Sign"
                            id="pickupSign"
                            name="pickupSign"
                            maxlength="200"
                            type="textarea"
                            :autosize="{ minRows: 1, maxRows: 5 }"
                            show-word-limit
                          >
                          </el-input>
                        </div>
                        <div
                          class="col-xl-4 col-lg-4 col-md-4 col-sm-12 col-12 alinmov2 align-self-center mt-mb-0 mt-2"
                          v-if="!pdfDataUrl"
                        >
                          <base-button
                            type="outline-neutral mr-2"
                            class="link min-button"
                            @click="uploadPickupSign"
                          >
                            <i class="flaticon-up-2"></i> Upload Pickup Sign
                            <input
                              type="file"
                              ref="pickupSign"
                              accept=".pdf"
                              model="pickupSign"
                              @change="readPickupSign"
                              class="d-none"
                            />
                          </base-button>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-xl-12">
                    <div class="card">
                      <h2 class="subtitle mb-3">Extras</h2>

                      <div class="row">
                        <div
                          class="col-xl-9 col-lg-9 col-md-9 col-sm-12 col-12 mb-3"
                        >
                          <label class="title-label" for="specialrequirements"
                            >Special Requirements</label
                          >
                          <el-input
                            v-model="reservation.special_requirements"
                            placeholder="Special Requirements"
                            id="Special Requirements"
                            name="Special Requirements"
                            maxlength="500"
                            type="textarea"
                            :autosize="{ minRows: 1, maxRows: 10 }"
                            show-word-limit
                          >
                          </el-input>
                        </div>

                        <div class="col-xl-3 col-lg-3 col-md-3 col-sm-6 col-12">
                          <base-input
                            type="number"
                            v-auto-zero
                            v-model.number="
                              $v.reservation.childSeatsCount.$model
                            "
                            mode="integer"
                            label="Child Seats N°"
                            id="child_seat"
                            name="child_seat"
                            placeholder="Child Seat"
                            indexTab="7"
                            :error="
                              childSeatsCountValidationMessage(
                                $v.reservation.childSeatsCount
                              )
                            "
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="col-xl-4 col-lg-12 pl-xl-0">
                <Charges
                  :serviceType="'transfer'"
                  :operation="'new'"
                  :currency="currency"
                  :pricing="reservation.pricing"
                  @addAdjustments="addAdjustments"
                  :mode="mode"
                />

                <div class="row">
                  <div class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12">
                    <div class="card pb-3">
                      <h2 class="subtitle mb-3">Payment Details</h2>

                      <div class="row">
                        <div
                          class="col-xl-12 col-lg-6 col-md-6 col-sm-6 col-12"
                        >
                          <WSelect
                            placeholder="Payment Type"
                            v-model="reservation.payment_type"
                            id="paymentType"
                            name="paymentType"
                            label="Payment Type"
                          >
                            <el-option
                              v-for="option in paymentMethods"
                              :value="option.value"
                              :label="option.label"
                              :key="option.label"
                            ></el-option>
                          </WSelect>
                        </div>

                        <div
                          class="col-xl-12 col-lg-6 col-md-6 col-sm-6 col-12"
                        >
                          <base-input
                            v-model.trim="reservation.invoice_number"
                            type="text"
                            label="Invoice Number"
                            placeholder="Invoice Number"
                            id="invoice_number"
                            name="invoice_number"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-xl-12 col-lg-6 col-md-6 col-sm-12 col-12">
                    <div class="card pb-3">
                      <h2 class="subtitle mb-3">External References</h2>

                      <div class="row">
                        <div
                          class="col-xl-12 col-lg-12 col-md-12 col-sm-6 col-12"
                        >
                          <base-input
                            type="text"
                            label="Reservation Reference"
                            placeholder="Reservation Reference"
                            v-model="$v.reservation.booking_reference.$model"
                            id="booking_reference"
                            name="booking_reference"
                            indexTab="28"
                            :error="
                              $v.reservation.booking_reference.$error
                                ? `Enter maximum ${$v.reservation.booking_reference.$params.maxLength.max} characters.`
                                : ''
                            "
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <AddDrivers
        :show="showAddModalDriver"
        :branchId="reservation.branch"
        @close="closeNewDriverModal"
        @input="addDriversInOptions"
      />
      <ManageExtraCharges
        :show="showExtrasModal"
        :markUp="customer ? customer.mark_up : 0"
        :markUpType="customer ? customer.type_markup : ''"
        :extras="reservation.pricing.extras"
        :currency="currency"
        @change="manageExtras"
        @close="closeExtrasModal"
      />
      <ManageDiscounts
        :show="showDiscountModal"
        :grossPrice="reservation.pricing.gross_price.last_amount"
        :discounts="reservation.pricing.discounts"
        :currency="currency"
        @change="manageDiscounts"
        @close="closeDiscountModal"
      />
      <modal
        v-if="pdfDataUrl"
        :show.sync="showPreviewPickupSign"
        modal-classes="modal-dialog-centered modal-xl"
        body-classes="pt-1"
      >
        <template slot="header">
          <h4 class="subtitle mb-0" id="BlackoutDate">Pickup Sign</h4>
        </template>

        <iframe
          :src="`${pdfDataUrl}#zoom=100`"
          width="100%"
          height="600px"
        ></iframe>
      </modal>
    </div>
  </section>
</template>

<script>
// @ is an alias to /src
import { v4 as uuidv4 } from "uuid";
import moment from "moment-timezone";
moment.suppressDeprecationWarnings = true;
import { mapGetters, mapActions, mapMutations } from "vuex";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import endpoint from "../../Commons/Services/index";
import Swal from "sweetalert2";
import { helpers } from "vuelidate/lib/validators";
const ValName = helpers.regex("alphaCha", /^[a-zA-ZÑñáéíóúüüÜÁÉÍÓÚ'-\s]*$/);
import { VueTelInput } from "vue-tel-input";
import WSelect from "@/components/Select";
import AddCustomers from "../components/AddCustomers";
import ManageExtraCharges from "../components/ManageExtrasCharges";
import ManageDiscounts from "../components/ManageDiscounts";
import Charges from "../components/Charges";
import AddDrivers from "../components/AddDriver";
import ServicesCard from "../components/ServicesCard.vue";

import {
  required,
  minLength,
  maxLength,
  alphaNum,
  email,
  maxValue,
  minValue,
  numeric,
  integer,
  requiredIf
} from "vuelidate/lib/validators";
import {
  Tabs,
  TabPane,
  TableColumn,
  DropdownMenu,
  DropdownItem,
  Dropdown,
  DatePicker,
  TimeSelect
} from "element-ui";
import { cloneDeep, isEqual } from "lodash";
import debounce from "lodash.debounce";
import upload from "../../Commons/Utility/Upload";
import path from "path";
import {
  formatBookingType,
  formatPaymentType,
  formatPickupDate,
  formatPickupTime,
  formatVehicleCategory
} from "../services/format.service";
import {
  getFlightType,
  MINIMUM_SELECT,
  PAYMENT_METHODS,
  RESERVATION_OPTIONS,
  getLabelTransport,
  getTransportReference
} from "../../../helpers/reservation.helpers";
import { goBack, unauthorizedAction } from "../../../helpers/commons.helpers";
import FlightNumberInput from "../components/FlightValidation/FlightNumberInput.vue";
import FlightDetails from "../components/FlightValidation/FlightDetails.vue";
import {
  generateMessageToNotify,
  getPickupDate,
  getPickupTime
} from "../services/flight.service";

import {
  childSeatsCountValidationMessage,
  fromValidationMessage,
  passengerCountValidationMessage,
  toValidationMessage
} from "../services/validation.service";
import {
  buildUtcPickupDateTime,
  canBeRequoted,
  handleBlackoutConfirmation,
  handleCutOffConfirmation
} from "../services/quote.service";
import {
  calculateTotalDiscounts,
  calculateTotalExtraGrossPrice,
  calculateTotalExtrasNetPrice,
  calculateTotalGrossPrice,
  calculateTotalNetPrice,
  calculateTotalNetProfit,
  calculateTotalPrice,
  isSamePriceComposition,
  isSameSurchargesComposition,
  normalizePriceAmount
} from "../services/price.service";
import { alphabeticallySort } from "../services/client.service";

WSelect.computed.readonly = function() {
  const isIE = !this.$isServer && !Number.isNaN(Number(document.documentMode));
  return (
    !this.filterable ||
    this.multiple ||
    (!isIE && !this.visible && !this.remote)
  );
};

export default {
  name: "NewReservations",
  data() {
    return {
      debouncedRequote: null,
      reservation: {
        from: "",
        to: "",
        pickup_date: "",
        pickup_time: "",
        passengersCount: 0,
        childSeatsCount: 0,
        type: "arrival",
        supplier: null,
        branch: null,
        service: null,
        driver: null,
        vehicle: null,
        payment_type: "card",
        payment_reference: "",
        flight_number: "",
        transfer: "one-way",
        customer: null,
        booking_reference: "",
        pickupSign: {
          format: "CUSTOM",
          text: "",
          link: ""
        },
        special_requirements: "",
        status: "NW",
        number_hourly: 0,
        number_stations: "",
        cruise_line: "",
        irraival: false,
        invoice_number: "",
        surcharges: [],
        locations: {
          from: {
            lat: 0,
            lng: 0
          },
          to: {
            lat: 0,
            lng: 0
          }
        },
        distancematrix: {
          distance: 0,
          duration: 0
        },
        originData: null,
        destinationData: null,
        owner: "supplier",
        chauffeur: {
          name: "",
          email: "",
          phone: "",
          gender: ""
        },
        passengers: [],
        pricing: {
          net_price: {
            amount: 0.0,
            last_amount: 0.0,
            composition: []
          },
          base_price: {
            amount: 0.0,
            last_amount: 0.0,
            composition: []
          },
          gross_price: {
            amount: 0.0,
            last_amount: 0.0,
            composition: []
          },
          net_profit: {
            amount: 0.0,
            last_amount: 0.0,
            composition: []
          },
          sale_price: {
            amount: 0.0,
            last_amount: 0.0,
            composition: []
          },
          discounts: [],
          extras: [],
          totals: {
            discounts: 0.0,
            extras: {
              gross_price: 0.0,
              net_price: 0.0,
              net_profit: 0.0
            },
            net_price: 0.0,
            gross_price: 0.0,
            net_profit: 0.0
          },
          reason_adjustment: ""
        },
        responsible: {
          type: "Users",
          ref: ""
        },
        notificaition: {
          configTag: "rhomtrip_supplier",
          configRef: null
        },
        source: {
          origin: "RhomTrip Suppliers",
          type: "INTERNAL",
          provider: "RHOMTRIP",
          channel: "SYSTEM",
          medium: "APP"
        },
        flight: null
      },
      contactNumber: "",
      paymentMethods: PAYMENT_METHODS,
      reservationOptions: RESERVATION_OPTIONS,
      services: [],
      all_services: [],
      serviceAux: [],
      customer: null,
      minimumSelect: MINIMUM_SELECT,
      branchesOptions: [],
      driversOptions: [],
      branchFilter: "",
      supplier: null,
      branch: null,
      loading: false,
      optionsFrom: [],
      customers: [],
      optionsTo: [],
      service: null,
      type_request: "one_way",
      buttonDisabled: false,
      reservationCopy: {},
      saved: false,
      copyData: false,
      currency: {
        symbol: "€",
        code: "EUR"
      },
      timezone: "",
      drivers: [],
      driver: null,
      country_code: "",
      modalCustomer: false,
      automaticDriverSelection: true,
      originData: null,
      destinationData: null,
      loaderService: "INIT",
      driverFilter: "",
      passenger: {
        _id: null,
        reference: uuidv4(),
        firstName: "",
        lastName: "",
        fullName: "",
        email: "",
        phone: "",
        gender: "other",
        type: "ADULT",
        primary: true,
        flightNumber: ""
      },
      imageProfile: require("rhomtrip_assets/src/img/users/user-placeholder.png"),
      mode: "edit",
      showDiscountModal: false,
      showExtrasModal: false,
      showAddModalDriver: false,
      driverId: null,
      pdfDataUrl: null,
      showPreviewPickupSign: false,
      routerReference: {
        transferType: "arrival",
        value: ""
      },
      flights: [],
      flightType: "NONE",
      flight: null,
      airport: null,
      flightValidationRoles: {},
      loaderVerifyFlight: false
    };
  },
  watch: {
    "reservation.type": function(newValue, oldValue) {
      if (newValue === "hourly") {
        this.reservation.to = "";
        this.type_request = "hourly";
      } else {
        this.type_request = "one_way";
      }
    },
    "reservation.branch": {
      handler: function(current, old) {
        if (current) {
          let branch = this.branchesOptions.filter(
            branch => branch._id === current
          );
          this.branch = branch[0];
        }
      },
      deep: true
    },
    customerOptions: {
      handler: function(current, old) {
        this.customers = current;
      },
      deep: true
    }
  },
  created() {
    this.debouncedRequote = debounce(this.requote, 500);
    var bread = [
      {
        text: "Reservations",
        to: "/reservations"
      },
      {
        text: "New Reservation",
        active: true
      }
    ];
    this.setItemsBread(bread);
    this.customers = this.customerOptions;
    this.reservation.responsible = this.getResponsable(this.sesion);
    this.reservation.notificaition.configRef = this.sesion.account_type.owner;
    this.reservationCopy = cloneDeep(this.reservation);
  },
  methods: {
    formatBookingType,
    formatVehicleCategory,
    formatPickupDate,
    formatPickupTime,
    getFlightType,
    formatPaymentType,
    fromValidationMessage,
    toValidationMessage,
    passengerCountValidationMessage,
    childSeatsCountValidationMessage,
    getLabelTransport,
    getTransportReference,
    normalizePriceAmount,
    /*<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<Pricing Methods>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/
    calculePriceByCustomer(netPrice, markUp, markUpType) {
      let grossPrice =
        markUpType === "markup"
          ? netPrice / (1 - markUp / 100)
          : netPrice * (1 - markUp / 100);

      let totalGrossPrice = calculateTotalPrice(
        parseFloat(grossPrice.toFixed(2)),
        this.reservation.surcharges,
        "gross"
      );
      this.reservation.pricing.gross_price.amount = parseFloat(
        totalGrossPrice.toFixed(2)
      );
      this.reservation.pricing.gross_price.last_amount = this.reservation.pricing.gross_price.amount;

      let netProfit = this.reservation.pricing.gross_price.amount - netPrice;
      this.reservation.pricing.net_profit.amount = parseFloat(
        netProfit.toFixed(2)
      );
      this.reservation.pricing.net_profit.last_amount = this.reservation.pricing.net_profit.amount;

      this.populatePricing(
        this.reservation.pricing.extras,
        this.reservation.pricing.discounts
      );
    },
    populatePricing(extras = [], discounts = []) {
      //Calculate Total Extras Net Price
      this.reservation.pricing.totals.extras.net_price = calculateTotalExtrasNetPrice(
        extras
      );
      //Calculate Total Extra Gross Price
      this.reservation.pricing.totals.extras.gross_price = calculateTotalExtraGrossPrice(
        extras
      );
      //Calculate Total Extras Net Profit
      this.reservation.pricing.totals.extras.net_profit =
        this.reservation.pricing.totals.extras.gross_price -
        this.reservation.pricing.totals.extras.net_price;

      //Calculate Total Discounts
      this.reservation.pricing.totals.discounts = calculateTotalDiscounts(
        discounts
      );

      //Calculate Total Net Price
      this.reservation.pricing.totals.net_price = calculateTotalNetPrice([
        this.reservation.pricing.totals.extras.net_price,
        this.reservation.pricing.net_price.last_amount
      ]);

      //Calculate Total Gross Price
      let totalsGrossPrice = calculateTotalGrossPrice([
        this.reservation.pricing.totals.extras.gross_price,
        this.reservation.pricing.gross_price.last_amount
      ]);
      this.reservation.pricing.totals.gross_price =
        totalsGrossPrice - this.reservation.pricing.totals.discounts;

      //Calculate Total Net profit
      this.reservation.pricing.totals.net_profit = calculateTotalNetProfit(
        this.reservation.pricing.totals.gross_price,
        this.reservation.pricing.totals.net_price,
        0,
        0
      );
    },
    openDiscountModal(service, customer) {
      if (service && customer) {
        this.showDiscountModal = true;
      } else {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `We have detected that you have not selected any service and customer.`,
          icon: "flaticon-warning-1"
        });
      }
    },
    closeDiscountModal() {
      this.showDiscountModal = false;
    },
    manageDiscounts(discounts = []) {
      this.reservation.pricing.discounts = discounts;
      this.populatePricing(
        this.reservation.pricing.extras,
        this.reservation.pricing.discounts
      );
      this.showDiscountModal = false;
    },
    openExtrasModal(service, customer) {
      if (service && customer) {
        this.showExtrasModal = true;
      } else {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `We have detected that you have not selected any service and customer.`,
          icon: "flaticon-warning-1"
        });
      }
    },
    closeExtrasModal() {
      this.showExtrasModal = false;
    },
    manageExtras(extras = []) {
      this.reservation.pricing.extras = extras;
      this.populatePricing(
        this.reservation.pricing.extras,
        this.reservation.pricing.discounts
      );
      this.showExtrasModal = false;
    },
    addAdjustments(adjustment) {
      if (adjustment === "discounts") {
        this.openDiscountModal(
          this.reservation.service,
          this.reservation.customer
        );
      } else {
        this.openExtrasModal(
          this.reservation.service,
          this.reservation.customer
        );
      }
    },
    /*<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<Passenger & Customer Methods>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/
    populatePassengers() {
      this.passenger.fullName = `${this.passenger.firstName} ${this.passenger.lastName}`;
      this.passenger.primary = true;
      this.reservation.passengers = [this.passenger];
      this.populatePickupSign();
    },
    addCustomerInOptions(customer) {
      if (customer !== null) {
        this.customers.push(customer);
        this.customers = alphabeticallySort(this.customers);
        this.customer = customer;
        this.reservation.customer = customer._id;
        this.setCustomerOptions(this.customerOptions.concat([customer]));
      }
    },
    closeNewCustomerModal(status) {
      this.modalCustomer = false;
      if (!status && this.customer) {
        this.reservation.customer = this.customer._id;
      }
    },
    async getCustomer(input = "") {
      try {
        if (input !== "" && input.length > 2) {
          this.loading = true;
          this.customers = this.customerOptions.filter(customer => {
            let name = `${customer.first_name} ${customer.last_name}`;
            return (
              name.toLowerCase().includes(input.trim().toLowerCase()) ||
              customer.company_name.toLowerCase().includes(input.toLowerCase())
            );
          });
          this.loading = false;
        } else {
          this.customers = this.customerOptions;
        }
      } catch (error) {
        this.customers = this.customerOptions;
      }
    },
    copyDataCustomer() {
      if (this.customer) {
        this.passenger.firstName = this.customer.first_name;
        this.passenger.lastName = this.customer.last_name;
        this.passenger.fullName = `${this.customer.first_name} ${this.customer.last_name}`;
        this.passenger.email = this.customer.email;
        this.passenger.phone = this.customer.phone;
        this.contactNumber = this.customer.phone;
        this.passenger.gender = this.customer.gender;
        this.passenger.flightNumber = this.reservation.flight_number;
        this.passenger.primary = true;
        this.reservation.passengers = [this.passenger];
        this.populatePickupSign();
      }
    },
    async selectCustomer(customerId) {
      if (customerId) {
        if (!this.service) {
          this.$notify({
            type: "warning",
            title: "Important!",
            message: `We have detected that you have not selected any available service.`,
            icon: "flaticon-warning-1"
          });
          this.reservation.customer = null;
        } else {
          this.customer = this.customers.find(customer => {
            return customer._id === customerId;
          });
          let customer = this.customer;
          this.copyData = true;
          this.calculePriceByCustomer(
            this.reservation.pricing.net_price.last_amount,
            customer.mark_up,
            customer.type_markup
          );
        }
      }
    },
    /*<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<Request Service Methods>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/
    async getRatesWithTheOrigin(value) {
      try {
        const isRequotable = canBeRequoted(
          this.reservation.type,
          value,
          this.reservation.to,
          this.reservation.pickup_date,
          this.reservation.pickup_time,
          this.reservation.passengersCount
        );
        if (isRequotable) {
          this.debouncedRequote();
        }
      } catch (error) {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `Please verify your Address / Date & Time information.`,
          icon: "flaticon-warning-1"
        });
      }
    },
    async getRatesWithTheDestination(value) {
      try {
        const isRequotable = canBeRequoted(
          this.reservation.type,
          this.reservation.from,
          value,
          this.reservation.pickup_date,
          this.reservation.pickup_time,
          this.reservation.passengersCount
        );
        if (isRequotable) {
          this.debouncedRequote();
        }
      } catch (error) {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `Please verify your Address / Date & Time information.`,
          icon: "flaticon-warning-1"
        });
      }
    },
    async getRatesWithThePickupDate(value) {
      try {
        const isRequotable = canBeRequoted(
          this.reservation.type,
          this.reservation.from,
          this.reservation.to,
          value,
          this.reservation.pickup_time,
          this.reservation.passengersCount
        );
        if (isRequotable) {
          this.debouncedRequote();
        }
      } catch (error) {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `Please verify your Address / Date & Time information.`,
          icon: "flaticon-warning-1"
        });
      }
    },
    async getRatesWithThePickupTime(value) {
      try {
        const isRequotable = canBeRequoted(
          this.reservation.type,
          this.reservation.from,
          this.reservation.to,
          this.reservation.pickup_date,
          value,
          this.reservation.passengersCount
        );
        if (isRequotable) {
          this.debouncedRequote();
        }
      } catch (error) {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `Please verify your Address / Date & Time information.`,
          icon: "flaticon-warning-1"
        });
      }
    },
    async getRatesWithTheNumberPassengers(value) {
      try {
        const isRequotable = canBeRequoted(
          this.reservation.type,
          this.reservation.from,
          this.reservation.to,
          this.reservation.pickup_date,
          this.reservation.pickup_time,
          parseInt(value)
        );
        if (isRequotable) {
          this.debouncedRequote();
        }
      } catch (error) {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `Please verify your Address / Date & Time information.`,
          icon: "flaticon-warning-1"
        });
      }
    },
    async getRatesWithTheHourly(value) {
      try {
        const isRequotable = canBeRequoted(
          this.reservation.type,
          this.reservation.from,
          this.reservation.to,
          this.reservation.pickup_date,
          this.reservation.pickup_time,
          this.reservation.passengersCount
        );
        if (isRequotable && parseInt(value) > 0) {
          this.debouncedRequote();
        }
      } catch (error) {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `Please verify your Address / Date & Time information.`,
          icon: "flaticon-warning-1"
        });
      }
    },

    buildRateOptionsRequestBody() {
      return {
        passengersCount: this.reservation.passengersCount,
        origin:
          this.reservation.type === "arrival"
            ? this.originData
            : this.reservation.from,
        destination:
          this.reservation.type === "departure"
            ? this.destinationData
            : this.reservation.to,
        pickup_date: this.reservation.pickup_date,
        pickup_time: this.reservation.pickup_time,
        type_request: this.type_request,
        hours: this.reservation.number_hourly,
        arrival: this.flightType === "ARRIVAL",
        childSeatsCount: this.reservation.childSeatsCount,
        serviceType: "TRANSFER",
        source: "rhombus-v1"
      };
    },
    async getBookingOptions() {
      try {
        let payload = this.buildRateOptionsRequestBody();
        this.loaderService = "SEARCHING";
        let {
          data
        } = await endpoint.rates.services.getTransferPricingQuotation(
          payload,
          this.sesion.token
        );
        if (data) {
          this.reservation.locations.from = data.origin;
          this.reservation.locations.to = data.destination;
          this.reservation.distancematrix.distance = data.distance;
          this.reservation.distancematrix.duration = data.duration;
          this.timezone = data.timezone;
          this.services = data.services;
          this.all_services = data.all_services;
          this.serviceAux = this.services;
          this.branchesOptions = data.branches;
          this.drivers = data.drivers;
          this.driversOptions = data.drivers;
          this.loaderService = this.serviceAux.length ? "RESULTS" : "NOT_FOUND";
        } else {
          this.services = [];
          this.serviceAux = [];
          this.branchesOptions = [];
          this.driversOptions = [];
          this.loaderService = "NOT_FOUND";
        }
      } catch (error) {
        this.services = [];
        this.branchesOptions = [];
        this.driversOptions = [];
        this.loaderService = "NOT_FOUND";
      }
    },
    async requote() {
      this.showRates = true;
      this.branchFilter = "";
      this.driverFilter = "";
      this.branchesOptions = [];
      this.driversOptions = [];
      await this.getBookingOptions();
      let serviceId = this.service ? this.service._id : null;
      let currentService = this.getServiceById(serviceId, this.services);
      this.reservation.service = null;
      this.service = null;
      if (currentService) {
        this.processServiceSelection(currentService);
      }
    },
    getServiceById(serviceId, services = []) {
      return services.find(service => service._id === serviceId) || null;
    },
    getSelectServices(serviceSelected, element) {
      if (serviceSelected) {
        return serviceSelected._id === element._id;
      }
      return false;
    },
    /*<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<Location Methods>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/
    getTypeLocation(type, origin) {
      if (type === "arrival" && origin === "from") {
        return "airport";
      } else if (type === "departure" && origin === "to") {
        return "airport";
      } else {
        return "point_of_interest";
      }
    },
    async getLocationFrom(input) {
      try {
        if (input !== "" && input.length > 2) {
          let type = this.getTypeLocation(this.reservation.type, "from");
          this.loading = true;
          let {
            data
          } = await endpoint.countries.services.autocompleteLocations(
            input,
            type
          );
          this.loading = false;
          if (data.code === 200) {
            let locations = data.data;
            this.optionsFrom = locations;
          } else {
            this.optionsFrom = [];
          }
        } else {
          this.optionsFrom = [];
        }
      } catch (error) {
        this.optionsFrom = [];
      }
    },
    async getLocationTo(input) {
      try {
        if (input !== "" && input.length > 2) {
          let type = this.getTypeLocation(this.reservation.type, "to");
          this.loading = true;
          let {
            data
          } = await endpoint.countries.services.autocompleteLocations(
            input,
            type
          );
          this.loading = false;
          if (data.code === 200) {
            let locations = data.data;
            this.optionsTo = locations;
          } else {
            this.optionsTo = [];
          }
        } else {
          this.optionsTo = [];
        }
      } catch (error) {
        this.loading = false;
        this.optionsTo = [];
      }
    },
    async populateOringData(from) {
      if (from) {
        let element = this.optionsFrom.find(item => item.select === from);
        if (element) {
          this.country_code = element.country_code;
          if (element.type === "airport") {
            this.originData = element;
            this.reservation.originData = element;
            this.flightType = "ARRIVAL";
            this.airport = element.metadata ? element.metadata : {};
          } else {
            this.originData = null;
            this.reservation.originData = null;
          }
        }
      }
    },
    async populateDestinationData(to) {
      if (to) {
        let element = this.optionsTo.find(item => item.select === to);
        if (element) {
          if (element.type === "airport") {
            this.destinationData = element;
            this.reservation.destinationData = element;
            this.flightType = "DEPARTURE";
            this.airport = element.metadata ? element.metadata : {};
          } else {
            this.destinationData = null;
            this.reservation.destinationData = null;
          }
        }
      }
    },
    async selectFrom(from) {
      await this.populateOringData(from);
      await this.getRatesWithTheOrigin(from);
    },
    async selectTo(to) {
      await this.populateDestinationData(to);
      await this.getRatesWithTheDestination(to);
    },
    /*<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<Pickup Sign Methods>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/
    populatePickupSign() {
      this.reservation.pickupSign.format = "CUSTOM";
      this.reservation.pickupSign.link = "";
      this.reservation.pickupSign.text = `${this.getTitleByGender(
        this.passenger.gender
      )} ${this.passenger.firstName} ${this.passenger.lastName}`;
    },
    async uploadPickupSign(event) {
      this.$refs.pickupSign.click();
    },
    async readPickupSign(event) {
      this.reservation.pickupSign.text = "";
      this.reservation.pickupSign.format = "FILE";
      await this.uploadPickupSignFile(event);
    },
    async uploadPickupSignFile(event) {
      try {
        const [file] = event.target.files;
        if (file && file.type === "application/pdf") {
          if (file.size > 2 * 1024 * 1024) {
            event.preventDefault();
            this.$notify({
              type: "danger",
              title: "Error!",
              message: "The file can't be larger than 2MB",
              icon: "flaticon-remove"
            });
            this.clearfile();
          } else {
            this.pdfDataUrl = URL.createObjectURL(file);
            let urlFile = await upload.uploadFile(
              file,
              upload.buildQueryString(
                upload.getFileData(
                  "/uploads/pdf/signs",
                  path.extname(file.name)
                )
              )
            );
            if (urlFile) {
              this.reservation.pickupSign.link = urlFile;
            } else {
              this.$notify({
                type: "danger",
                title: "Error!",
                message:
                  "The image cannot be larger than 2MB or exceed 500px x 500px dimensions",
                icon: "flaticon-remove"
              });
            }
          }
        } else {
          this.$notify({
            type: "warning",
            title: "Warning!",
            message:
              "There is an error in the imported file, please check the data and try the upload again",
            icon: "flaticon-warning-1"
          });
        }
      } catch (error) {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: "The file couldn't be imported. Please try again",
          icon: "flaticon-remove"
        });
      }
    },
    clearfile() {
      this.pdfDataUrl = null;
      this.reservation.pickupSign.link = "";
      this.populatePickupSign();
    },
    openPreviewPickup() {
      this.showPreviewPickupSign = true;
    },
    /*<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<Service Selection Methods>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/
    async handleCutOff(confirmed, service) {
      if (confirmed) {
        await this.applyServiceToReservation(service, this.customer);
      } else {
        this.service = null;
        this.reservation.service = null;
      }
    },
    async handleBlackoutService(confirmed, service) {
      if (confirmed) {
        await this.handleServiceSelection(service);
      } else {
        this.service = null;
        this.reservation.service = null;
      }
    },
    async handleServiceSelection(service) {
      if (this.service) {
        const isDifferentServiceId = this.service._id !== service._id;
        const samePriceComposition = isSamePriceComposition(
          this.service.basePriceComposition,
          service.basePriceComposition
        );
        const sameSurchargesComposition = isSameSurchargesComposition(
          this.service.surcharges,
          service.surcharges
        );
        if (
          isDifferentServiceId ||
          !samePriceComposition ||
          !sameSurchargesComposition
        ) {
          await this.validateAndApplyService(service);
        }
        return;
      }
      await this.validateAndApplyService(service);
      return;
    },
    async processServiceSelection(service) {
      try {
        if (service.blackout) {
          await handleBlackoutConfirmation(service, this.handleBlackoutService);
        } else {
          await this.handleServiceSelection(service);
        }
      } catch (error) {
        this.service = null;
        this.reservation.service = null;
      }
    },
    async validateAndApplyService(service) {
      const isCutoffTimeApplied = service.isCutoffTimeApplied;
      if (!isCutoffTimeApplied) {
        await this.applyServiceToReservation(service, this.customer);
      } else {
        await handleCutOffConfirmation(service, this.handleCutOff);
      }
    },
    applyServiceToReservation(service, customer) {
      this.service = service;
      this.reservation.supplier = service.supplierId;
      this.reservation.branch = service.branchId;
      this.reservation.service = service._id;
      this.reservation.vehicle = service.vehicle._id;

      this.reservation.surcharges = service.surcharges;

      this.driverAssign(service.vehicle._id, this.automaticDriverSelection);

      let base_price = parseFloat(service.base_price.toFixed(2));
      this.reservation.pricing.base_price.amount = base_price;
      this.reservation.pricing.base_price.last_amount = base_price;
      this.reservation.pricing.base_price.composition =
        service.basePriceComposition;

      let sale_price = parseFloat(service.sale_price.toFixed(2));
      this.reservation.pricing.sale_price.amount = sale_price;
      this.reservation.pricing.sale_price.last_amount = sale_price;

      let net_price = calculateTotalPrice(
        base_price,
        this.reservation.surcharges,
        "net"
      );
      this.reservation.pricing.net_price.amount = parseFloat(
        net_price.toFixed(2)
      );
      this.reservation.pricing.net_price.last_amount = this.reservation.pricing.net_price.amount;

      this.currency.symbol = service.currency.symbol;
      this.currency.code = service.currency.code;
      if (customer) {
        this.calculePriceByCustomer(
          this.reservation.pricing.net_price.last_amount,
          customer.mark_up,
          customer.type_markup
        );
      }
    },
    /*<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<Save Reservation Methods>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/
    getPickupTime(pickupTime, formatTime) {
      return moment(pickupTime, formatTime).format("hh:mm A");
    },
    async saveReservation(route = null) {
      if (!this.$v.reservation.$invalid && !this.$v.passenger.$invalid) {
        let reservation = cloneDeep(this.reservation);
        reservation.pickup_time = this.getPickupTime(
          reservation.pickup_time,
          this.formatTime
        );
        reservation.pickup_date = buildUtcPickupDateTime(
          reservation.pickup_date,
          reservation.pickup_time
        );
        reservation["irraival"] = this.flightType === "ARRIVAL";
        await this.createReservation(reservation, route);
      } else {
        this.$v.reservation.$touch();
        this.$v.passenger.$touch();
        if (this.$v.reservation.passengersCount.$invalid) {
          this.$notify({
            type: "warning",
            title: "Important!",
            message: `The number of PAX does not match the number of PAX added to the list.`,
            icon: "flaticon-warning-1"
          });
        } else {
          this.$notify({
            type: "warning",
            title: "Important!",
            message: "Please complete the required attributes",
            icon: "flaticon-warning-1"
          });
        }
      }
    },
    async createReservation(reservation, route = null) {
      try {
        this.setLoad(true);
        this.buttonDisabled = true;
        let { data } = await endpoint.reservations.services.newReservation(
          reservation,
          this.sesion.token
        );
        this.setLoad(false);
        this.buttonDisabled = false;
        if (data.code === 201) {
          this.$notify({
            type: "success",
            title: "Success!",
            message: "The reservations has been Saved",
            icon: "flaticon-check-3"
          });
          this.saved = true;
          this.$router.push(route ? route : "/reservations");
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message:
              "There was an error saving the reservation, please try again",
            icon: "flaticon-remove"
          });
        }
      } catch (error) {
        this.setLoad(false);
        this.buttonDisabled = false;
        this.handleError(
          error,
          "There was an error saving your reservation, please try again"
        );
      }
    },
    /*<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<Router Reference Methods>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/
    changeRouterReference(value) {
      this.routerReference = {
        transferType: this.reservation.type,
        value
      };
    },
    getRouterReferenceValue(transferType, routerReference) {
      if (transferType === routerReference.transferType) {
        return routerReference.value;
      } else {
        return transferType === "hourly" ? 0 : "";
      }
    },
    changeReservationTransferType(type) {
      let routerReferenceValue = this.getRouterReferenceValue(
        type,
        this.routerReference
      );
      if (["arrival", "departure"].includes(type)) {
        this.type_request = "one_way";
        this.reservation.flight_number = routerReferenceValue;
        this.reservation.number_stations = "";
        this.reservation.cruise_line = "";
        this.reservation.number_hourly = 0;
      } else if (type === "station") {
        this.type_request = "one_way";
        this.reservation.flight_number = "";
        this.reservation.number_stations = routerReferenceValue;
        this.reservation.cruise_line = "";
        this.reservation.number_hourly = 0;
      } else if (type === "port") {
        this.type_request = "one_way";
        this.reservation.flight_number = "";
        this.reservation.number_stations = "";
        this.reservation.cruise_line = routerReferenceValue;
        this.reservation.number_hourly = 0;
      } else if (type === "hourly") {
        this.type_request = "hourly";
        this.reservation.to = "";
        this.reservation.flight_number = "";
        this.reservation.number_stations = "";
        this.reservation.cruise_line = "";
        this.reservation.number_hourly = routerReferenceValue;
      } else {
        this.type_request = "one_way";
        this.reservation.flight_number = "";
        this.reservation.number_stations = "";
        this.reservation.cruise_line = "";
        this.reservation.number_hourly = 0;
      }
    },
    /*<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<Flight Methods>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/
    /**
     * Handle flight selection and update reservation details
     * @param {Object} payload - The flight selection payload
     */
    async handleFlightSelection(payload) {
      const { flight, isAdjustingDateTime, flightType } = payload;
      this.flight = flight;
      this.flight.isAdjustingDateTime = isAdjustingDateTime;
      this.flight.flightType = flightType;
      this.reservation.flight = cloneDeep(flight);
      this.changeRouterReference(this.reservation.flight_number);
      if (isAdjustingDateTime) {
        const date =
          flightType === "ARRIVAL" ? flight.arrivaltime : flight.departuretime;
        const timezone =
          flightType === "ARRIVAL"
            ? flight.destination.timezone
            : flight.origin.timezone;

        this.reservation.pickup_date = getPickupDate(date, timezone);
        if (flightType === "ARRIVAL") {
          this.reservation.pickup_time = getPickupTime(
            date,
            timezone,
            this.formatTime
          );
        }
        this.$notify({
          type: "info",
          title: "Important!",
          message: generateMessageToNotify(flightType),
          icon: "flaticon-notification-bell-outline-interface-symbol"
        });
        await this.requote();
      }
    },
    /**
     * Handle flight validation rules
     * @param {Object} rules - The flight validation rules
     */
    handleValidationState(rules) {
      this.flightValidationRoles = { ...rules };
    },
    /**
     * Reset flight details when flight number input changes
     */
    onFlightNumberInput(flightNumber) {
      if (!flightNumber) {
      }
    },
    async getFlightsInformationByIdent(ident) {
      this.loaderVerifyFlight = true;
      try {
        let {
          data
        } = await endpoint.flights.services.getFlightsInformationByIdent(
          ident,
          this.sesion.token
        );
        if (data.status) {
          window.open(
            `https://www.flightaware.com/live/flight/${data.data.ident}`,
            "_blank"
          );
        } else {
          this.$notify({
            type: "warning",
            title: "Important!",
            message: `We couldn't display the details of your flight. Please try again later.`,
            icon: "flaticon-warning-1"
          });
        }
      } catch (error) {
        this.$notify({
          type: "warning",
          title: "Important!",
          message: `We couldn't display the details of your flight. Please try again later.`,
          icon: "flaticon-warning-1"
        });
      }
      this.loaderVerifyFlight = false;
    },
    /*<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<Driver Methods>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/
    changeDriver(driverId) {
      let driver = this.driversOptions.find(driver => driver._id === driverId);
      if (driver) {
        this.reservation.driver = driverId;
        this.driver = this.populateDriver(driver);
        this.reservation.chauffeur = {
          name: `${this.driver.person.first_name} ${this.driver.person.last_name}`,
          email: this.driver.account.email,
          phone: this.driver.person.numbre_phone,
          gender: this.driver.person.gender
        };
        this.automaticDriverSelection = false;
      } else {
        this.reservation.chauffeur = {
          name: "Local RhomTrip Supplier",
          email: this.supplier.email,
          phone: this.supplier.phone,
          gender: ""
        };
        this.driver = null;
        this.driverId = null;
        this.reservation.driver = null;
        this.automaticDriverSelection = true;
      }
    },
    driverAssign(vehicleId, automaticDriverSelection) {
      if (!automaticDriverSelection) {
        this.driverId = this.driver._id;
        this.reservation.driver = this.driverId;
        this.reservation.chauffeur = {
          name: `${this.driver.person.first_name} ${this.driver.person.last_name}`,
          email: this.driver.account.email,
          phone: this.driver.person.numbre_phone,
          gender: this.driver.person.gender
        };
        this.automaticDriverSelection = false;
      } else {
        this.driver = this.getDriverByVehivleId(vehicleId);
        if (this.driver && this.driver.relationship.auto_assign) {
          this.driverId = this.driver._id;
          this.reservation.driver = this.driverId;
          this.reservation.chauffeur = {
            name: `${this.driver.person.first_name} ${this.driver.person.last_name}`,
            email: this.driver.account.email,
            phone: this.driver.person.numbre_phone,
            gender: this.driver.person.gender
          };
          this.automaticDriverSelection = true;
        } else {
          this.driver = null;
          this.driverId = null;
          this.reservation.driver = this.driverId;
          this.reservation.chauffeur = {
            name: "",
            email: "",
            phone: "",
            gender: ""
          };
          this.automaticDriverSelection = true;
        }
      }
    },
    getDriverByVehivleId(vehicleId) {
      try {
        let driver = this.drivers.find(element => {
          return element.relationship.vehicle === vehicleId;
        });
        return driver ? driver : null;
      } catch (error) {
        return null;
      }
    },
    populateDriver(driver) {
      return {
        _id: driver._id,
        person: {
          first_name: driver.person.first_name,
          last_name: driver.person.last_name,
          full_name: driver.person.full_name,
          gender: driver.person.gender,
          numbre_phone: driver.person.numbre_phone
        },
        profile: {
          image: driver.profile.image
        },
        relationship: {
          branch: driver.relationship.branch,
          auto_assign: driver.relationship.auto_assign
        },
        account: {
          email: driver.account.email
        }
      };
    },
    closeNewDriverModal(status) {
      this.showAddModalDriver = false;
    },
    addDriversInOptions(driver) {
      if (driver) {
        this.driversOptions.push(driver);
        this.driverId = driver._id;
        this.reservation.driver = this.driverId;
        this.driver = this.populateDriver(driver);
        this.reservation.chauffeur = {
          name: `${this.driver.person.first_name} ${this.driver.person.last_name}`,
          email: this.driver.account.email,
          phone: this.driver.person.numbre_phone,
          gender: this.driver.person.gender
        };
      }
      this.showAddModalDriver = false;
    },
    /*<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<Helpers Methods>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>*/
    changeBranch(value) {
      if (value !== "") {
        this.driverFilter = "";
        this.services = this.all_services;
        this.serviceAux = this.services.filter(service => {
          return service.branch === value;
        });
        this.driversOptions = this.drivers.filter(element => {
          return element.relationship.branch === value;
        });
      } else {
        this.driverFilter = "";
        this.serviceAux = this.all_services;
        this.driversOptions = [];
      }
    },
    phoneInput(value, payload) {
      let result = payload;
      if (result.isValid) {
        this.passenger.phone = result.number.e164;
        this.passenger.primary = true;
        this.reservation.passengers = [this.passenger];
      }
    },
    getIcon(type) {
      if (type === "airport") {
        return "flaticon-bold-plane";
      } else if (type === "lodging") {
        return "flaticon-bold-bed";
      } else if (type === "point_of_interest") {
        return "flaticon-bold-map";
      } else if (type === "route") {
        return "flaticon-bold-distance";
      } else if (type === "train_station" && type === "transit_station") {
        return "flaticon-bold-train";
      } else {
        return "flaticon-bold-map";
      }
    },
    handleError(error, message) {
      if (error.response) {
        let { data } = error.response;
        if (data.code === 401) {
          let auth = unauthorizedAction(error);
          if (auth) {
            this.setSigOut(true);
          }
        } else {
          this.$notify({
            type: "danger",
            title: "Error!",
            message: "The Operation could not be completed. Please try again",
            icon: "flaticon-remove"
          });
        }
      } else {
        this.$notify({
          type: "danger",
          title: "Error!",
          message: message,
          icon: "flaticon-remove"
        });
      }
    },
    goToPreviousPage() {
      goBack(this);
    },
    getTitleByGender(gender) {
      if (gender === "male") {
        return "Mr.";
      } else if (gender === "female") {
        return "Mrs.";
      } else if (gender === "other") {
        return "Mx.";
      } else {
        return "";
      }
    },
    onCopy() {
      this.$notify({
        type: "success",
        title: "Success!",
        message: "The text has been copied to the clipboard",
        icon: "flaticon-remove"
      });
    },
    onErrorCopy() {
      this.$notify({
        type: "danger",
        title: "Error!",
        message: "The text couldn't be copied",
        icon: "flaticon-remove"
      });
    },
    parseCustomerType(type) {
      if (type === "customer") {
        return "Customer";
      } else if (type === "travel_agency") {
        return "Travel Agency";
      } else if (type === "business") {
        return "Business";
      } else if (type === "travel_access") {
        return "Agent";
      } else {
        return "Customer";
      }
    },
    getResponsable(sesion) {
      return {
        ref: sesion.id,
        type: sesion.account_type.type !== "supplier" ? "Users" : "Operators"
      };
    },
    ...mapActions(["getSesion"]),
    ...mapMutations([
      "setSigOut",
      "setLoad",
      "setCustomerOptions",
      "setItemsBread"
    ])
  },
  components: {
    [Tabs.name]: Tabs,
    [TabPane.name]: TabPane,
    [TableColumn.name]: TableColumn,
    [Dropdown.name]: Dropdown,
    [DropdownItem.name]: DropdownItem,
    [DropdownMenu.name]: DropdownMenu,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect,
    flatPicker,
    VueTelInput,
    WSelect: WSelect,
    "add-customers": AddCustomers,
    ManageExtraCharges: ManageExtraCharges,
    ManageDiscounts: ManageDiscounts,
    Charges: Charges,
    AddDrivers: AddDrivers,
    ServicesCard: ServicesCard,
    FlightNumberInput,
    FlightDetails
  },
  validations: {
    contactNumber: {
      required,
      minLength: minLength(10),
      maxLength: maxLength(18)
    },
    reservation: {
      from: {
        required
      },
      to: {
        required: requiredIf(function(value) {
          return this.reservation.type !== "hourly";
        }),
        differentFromPickup: function(value) {
          if (this.reservation.type === "hourly") return true;
          return value !== this.reservation.from;
        }
      },
      pickup_date: {
        required
      },
      pickup_time: {
        required
      },
      passengersCount: {
        required,
        numeric,
        integer,
        minValue: minValue(1),
        maxValue: maxValue(85),
        customValidator: function(value) {
          return this.reservation.passengers.length <= value;
        }
      },
      customer: {
        required,
        alphaNum
      },
      service: {
        required
      },
      number_hourly: {
        required: requiredIf(function() {
          return this.reservation.type === "hourly";
        }),
        minValue: function(value) {
          if (this.reservation.type !== "hourly") return () => true;
          return value > 1;
        }
      },
      number_stations: {
        maxLength: maxLength(45)
      },
      cruise_line: {
        maxLength: maxLength(45)
      },
      flight_number: {
        required: requiredIf(function(value) {
          return false;
        }),
        isFlightValid(value) {
          if (!value) return true;
          const regex = /^[A-Z0-9]{1,3}?\d{1,5}[A-Z]?$/i;
          return regex.test(value.trim());
        },
        isValidate(value) {
          if (
            ["ARRIVAL", "DEPARTURE"].includes(
              this.flightValidationRoles.flightType
            )
          ) {
            return this.flightValidationRoles.isValidateFlightNumber;
          }
          return true;
        }
      },
      booking_reference: {
        maxLength: maxLength(25)
      },
      childSeatsCount: {
        numeric,
        integer,
        maxValue: maxValue(10)
      }
    },
    passenger: {
      firstName: {
        minLength: minLength(2),
        maxLength: maxLength(45),
        ValName
      },
      lastName: {
        minLength: minLength(2),
        maxLength: maxLength(45),
        ValName
      },
      phone: {
        minLength: minLength(10),
        maxLength: maxLength(17)
      },
      email: {
        email,
        minLength: minLength(3)
      }
    }
  },
  computed: {
    isFlightType() {
      return ["airport", "arrival", "departure"].includes(
        this.reservation.type
      );
    },
    ...mapGetters([
      "locations",
      "customerOptions",
      "sesion",
      "load",
      "sigout",
      "settings"
    ]),
    formatDate() {
      if (this.settings && this.settings.dateFormat) {
        return this.settings.dateFormat;
      }
      return "DD-MMM-YYYY";
    },
    formatTime() {
      if (this.settings && this.settings.timeFormat) {
        return this.settings.timeFormat;
      }
      return "hh:mm A";
    },
    formatDateFlatPicker() {
      if (this.settings) {
        if (this.settings.dateFormat === "DD-MMM-YYYY") {
          return "d-M-Y";
        } else if (this.settings.dateFormat === "DD/MM/YYYY") {
          return "d/m/Y";
        }
        return "m/d/Y";
      }
      return "d-M-Y";
    },
    formatTimeFlatPicker() {
      if (this.settings) {
        const is12HourFormat = this.settings.timeFormat === "hh:mm A";
        return {
          altFormat: is12HourFormat ? "G:i K" : "H:i",
          dateFormat: is12HourFormat ? "G:i K" : "H:i",
          time_24hr: is12HourFormat ? false : true
        };
      }
      return {
        altFormat: "G:i K",
        dateFormat: "G:i K",
        time_24hr: false
      };
    }
  },
  beforeRouteLeave(to, from, next) {
    if (!this.sigout) {
      let notChanged = isEqual(this.reservation, this.reservationCopy);
      if (!notChanged && !this.saved) {
        Swal.fire({
          title: "Important",
          html:
            "The Reservation has been modified.<br> Do you want to save changes?",
          imageUrl: require("rhomtrip_assets/src/img/icons/alerts/warning.png"),
          buttonsStyling: false,
          showCloseButton: true,
          showCancelButton: true,
          focusConfirm: false,
          reverseButtons: true,
          cancelButtonText: "No",

          confirmButtonText: "Yes",
          confirmButtonClass: "btn btn-primary btn-small-one"
        }).then(result => {
          if (result.value) {
            this.saveReservation(to.path);
          } else if (result.dismiss === Swal.DismissReason.cancel) {
            next();
          }
        });
      } else {
        next();
      }
    } else {
      next();
    }
  }
};
</script>
